<template>
  <div class="bill-page">
    <van-nav-bar title="话单" :border="false" />
    <div style="padding:0 16px 8px"><van-search v-model="keyword" placeholder="搜索号码/客户" shape="round" @search="onSearch" /></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
      <div class="dd-card bill-card" v-for="item in list" :key="item.ID" @click="showDetail(item)">
        <div class="bill-top"><span class="bill-tel">{{ item.tel }}</span><van-tag :type="item.call_result=='1'?'success':'danger'" size="medium">{{ item.call_result=='1'?'成功':'失败' }}</van-tag></div>
        <div class="bill-info"><span>{{ item.customer || '-' }}</span><van-tag v-if="item.grade" plain type="primary" size="small">{{ item.grade }}</van-tag></div>
        <div class="bill-bottom"><span>{{ formatTime(item.created_at) }}</span><span>{{ item.time_length || '-' }}秒</span></div>
      </div>
    </van-list>
    <van-action-sheet v-model="detailVisible" title="话单详情">
      <div style="padding:0 16px 20px" v-if="currentBill">
        <van-cell title="号码" :value="currentBill.tel" /><van-cell title="客户" :value="currentBill.customer||'-'" />
        <van-cell title="结果"><template #default><van-tag :type="currentBill.call_result=='1'?'success':'danger'">{{ currentBill.call_result=='1'?'成功':'失败' }}</van-tag></template></van-cell>
        <van-cell title="时长" :value="(currentBill.time_length||'-')+'秒'" /><van-cell title="评级" :value="currentBill.grade||'-'" />
        <van-cell title="时间" :value="formatTime(currentBill.created_at)" />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { getBillList } from '@/api'
export default {
  name: 'Bill',
  data() { return { keyword:'',list:[],page:1,pageSize:20,total:0,loading:false,finished:false,detailVisible:false,currentBill:null } },
  methods: {
    onSearch() { this.page=1;this.list=[];this.finished=false;this.loading=true;this.loadMore() },
    loadMore() { var self=this;getBillList({page:this.page,pageSize:this.pageSize,tel:this.keyword||undefined}).then(function(res){if(res.code===0){var nl=res.data.list||[];self.total=res.data.total||0;self.list=self.list.concat(nl);self.page++;if(self.list.length>=self.total)self.finished=true}else self.finished=true}).catch(function(){self.finished=true}).finally(function(){self.loading=false}) },
    showDetail(item) { this.currentBill=item;this.detailVisible=true },
    formatTime(v) { if(!v)return'-';if(v.indexOf('T')>=0)return v.replace('T',' ').substring(0,19);return v.substring(0,19) }
  }
}
</script>

<style scoped>
.bill-page { min-height:100vh; background:#F5F6FA; }
.bill-card { padding:12px 16px; }
.bill-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:4px; }
.bill-tel { font-size:16px;font-weight:700;color:#171A1D;font-family:'Courier New',monospace;letter-spacing:0.5px; }
.bill-info { font-size:13px;color:#666B78;margin-bottom:4px;display:flex;align-items:center;gap:6px; }
.bill-bottom { display:flex;justify-content:space-between;font-size:12px;color:#A0A4AE;padding-top:8px;border-top:1px solid #F5F6FA;margin-top:4px; }
</style>
